import { render } from "./DispText.vue?vue&type=template&id=31099c01"
import script from "./DispText.vue?vue&type=script&lang=js"
export * from "./DispText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataDisp/DispText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31099c01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31099c01', __exports__)) {
    console.log('reload')
    api.reload('31099c01', __exports__)
  }
  
  module.hot.accept("./DispText.vue?vue&type=template&id=31099c01", () => {
    console.log('re-render')
    api.rerender('31099c01', render)
  })

}


export default __exports__